(() => {
  const DATE = 'お届け希望日';
  const TIME = 'お届け希望時間帯';
  const slots = ['08:00–12:00', '14:00–16:00', '16:00–18:00', '18:00–20:00', '19:00–21:00'];
  const minDays = 5, maxDays = 10;
  const root = () => window.Shopify?.routes?.root || '/';
  const panel = () => document.querySelector('[data-cart-delivery-request]');
  let queue = Promise.resolve();
  let pending = 0;
  let checkout = false;
  let lastError = null;

  function dates(now = new Date()) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now).map(p => [p.type, p.value]));
    return Array.from({ length: maxDays - minDays + 1 }, (_, i) =>
      new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day + minDays + i)).toISOString().slice(0, 10));
  }
  function normalize(state, edits = {}, now = new Date()) {
    const values = { ...state.attributes, ...edits };
    return {
      [DATE]: !state.datetimeBlocked && !state.dateBlocked && dates(now).includes(values[DATE]) ? values[DATE] : '',
      [TIME]: !state.datetimeBlocked && slots.includes(values[TIME]) ? values[TIME] : ''
    };
  }
  function error(message = '') {
    const node = panel()?.querySelector('[data-delivery-error]');
    if (node) { node.textContent = message; node.hidden = !message; }
  }
  function busy() {
    panel()?.querySelectorAll('select').forEach(select => {
      select.disabled = pending > 0 || checkout ||
        panel().dataset.datetimeBlocked === 'true' ||
        (select.name === `attributes[${DATE}]` && panel().dataset.dateBlocked === 'true');
    });
  }
  async function state() {
    const response = await fetch(`${root()}?section_id=cart-delivery-state`, { cache: 'no-store' });
    if (!response.ok) throw new Error('お届け希望日時を確認できません。再度お試しください。');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-cart-delivery-state]');
    if (!node) throw new Error('お届け希望日時の設定を読み込めません。再読み込みしてください。');
    const value = JSON.parse(node.textContent);
    // Liquid may serialize an empty attributes collection as [].
    if (Array.isArray(value.attributes) && value.attributes.length === 0) value.attributes = {};
    if (typeof value.dateBlocked !== 'boolean' || !value.attributes || Array.isArray(value.attributes)) throw new Error('お届け希望日時の確認に失敗しました。');
    return value;
  }
  function render(current, values) {
    const element = panel();
    if (!element) return;
    element.dataset.dateBlocked = String(current.dateBlocked);
    element.dataset.datetimeBlocked = String(current.datetimeBlocked === true);
    element.querySelector('[data-delivery-date-field]').hidden = current.dateBlocked;
    element.querySelector('[data-delivery-date-message]').hidden = !current.dateBlocked;
    const dateSelect = element.querySelector(`[name="attributes[${DATE}]"]`);
    dateSelect.replaceChildren(new Option('指定しない', ''), ...dates().map(value => new Option(value.replaceAll('-', '.'), value)));
    dateSelect.value = values[DATE];
    element.querySelector(`[name="attributes[${TIME}]"]`).value = values[TIME];
    element.hidden = current.datetimeBlocked === true;
    busy();
  }
  async function reconcile(edits = {}) {
    const current = await state();
    const values = normalize(current, edits);
    const updates = {};
    for (const key of [DATE, TIME]) {
      if ((current.attributes[key] || '') !== values[key] || (key in current.attributes && !values[key])) updates[key] = values[key];
    }
    if (Object.keys(updates).length) {
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: updates })
      });
      if (!response.ok) throw new Error('お届け希望日時を保存できませんでした。選択し直してからお進みください。');
      const verified = await state();
      const expected = normalize(verified, values);
      for (const key of [DATE, TIME]) {
        if ((verified.attributes[key] || '') !== values[key] || expected[key] !== values[key]) throw new Error('カート内容が変わったため、お届け希望日時を再確認してください。');
      }
    }
    render(current, values);
    lastError = null;
    error();
  }
  function enqueue(edits, explicit = false) {
    pending += 1; busy();
    const run = async () => {
      if (lastError && !explicit) throw lastError;
      try { await reconcile(edits); }
      catch (failure) { lastError = failure; error(failure.message); throw failure; }
      finally { pending -= 1; busy(); }
    };
    // Always release the busy state, even when a prior save failure is latched.
    const operation = queue.then(async () => {
      if (lastError && !explicit) { pending -= 1; busy(); throw lastError; }
      return run();
    });
    queue = operation.catch(() => {});
    return operation;
  }
  document.addEventListener('change', event => {
    if (!event.target.closest?.('[data-cart-delivery-request]') || event.target.tagName !== 'SELECT') return;
    const key = event.target.name === `attributes[${DATE}]` ? DATE : TIME;
    enqueue({ [key]: event.target.value }, true).catch(() => {});
  });
  const refresh = () => { if (!checkout) enqueue().catch(() => {}); };
  ['cart:change', 'cart:refresh', 'cart-drawer:refreshed', 'shopify:section:load'].forEach(name => {
    document.addEventListener(name, refresh);
  });
  // A section can be replaced after cart:change has already completed.
  // Observe panel insertion only, not option changes performed by render().
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.matches?.('[data-cart-delivery-request]') || node.querySelector?.('[data-cart-delivery-request]')
    ))) refresh();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => { checkout = false; busy(); enqueue().catch(() => {}); });
  window.hugcoffeeDeliveryRequest = {
    async prepareCheckout() {
      checkout = true; busy();
      try { await enqueue(); }
      catch (failure) { checkout = false; busy(); throw failure; }
    },
    dates, normalize
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enqueue().catch(() => {}), { once: true });
  else enqueue().catch(() => {});
})();
